module.exports = __webpack_public_path__ + "img/site_logo.1daf6a14.png";